import Head from "next/head";

function FAQMetaHead(props: any) {
  const { contentIds } = props;
  let faqItems: any = [];
  contentIds.forEach((eachContent: any) => {
    const { content, uiType } = eachContent?.uiDetails || {};
    if (uiType === "FAQ" && content.faqs) {
      faqItems = faqItems.concat(content.faqs);
    }
  });
  if (!faqItems || faqItems.length === 0) {
    return null;
  }
  const microdata = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqItems.map((faqItem: any) => ({
      "@type": "Question",
      name: faqItem.question,

      acceptedAnswer: {
        "@type": "Answer",
        text: Array.isArray(faqItem.answer) ? faqItem.answer[0] : faqItem.answer || faqItem.article,
      },
    })),
  };

  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(microdata) }}
      />
    </Head>

  );
}

export default FAQMetaHead;
